if (!customElements.get('product-personalization')) {
  customElements.define(
    'product-personalization',
    class ProductPersonalization extends HTMLElement {
      connectedCallback() {
        this.toggle = this.querySelector('[data-personalization-toggle]');
        this.field = this.querySelector('[data-personalization-field]');
        this.nameInput = this.querySelector('[data-personalization-name]');
        this.feeInput = this.querySelector('[data-personalization-fee]');
        this.errorMessage = this.querySelector('[data-personalization-error]');
        this.form = this.closest('form');

        this.onToggle = this.onToggle.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.toggle.addEventListener('change', this.onToggle);
        // Capture phase: runs before ProductForm's own submit handler, so an empty name blocks the add.
        this.form?.addEventListener('submit', this.onSubmit, true);
        this.onToggle();
      }

      disconnectedCallback() {
        this.toggle?.removeEventListener('change', this.onToggle);
        this.form?.removeEventListener('submit', this.onSubmit, true);
      }

      // Disabled fields aren't submitted, so an unchecked box adds nothing to the cart.
      onToggle() {
        const active = this.toggle.checked;
        this.field.hidden = !active;
        this.nameInput.disabled = !active;
        this.feeInput.disabled = !active;
        this.setError(false);
        if (active) this.nameInput.focus();
      }

      onSubmit(event) {
        if (!this.toggle.checked || this.nameInput.value.trim()) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.setError(true);
        this.nameInput.focus();
      }

      setError(show) {
        this.errorMessage.hidden = !show;
        if (show) this.errorMessage.textContent = this.dataset.requiredText || '';
      }
    }
  );
}
